<template>
    <div>
        <div :class="{campagne:!isMobile,mCampagne:isMobile,}">
            <h3 class="title">{{ campagne.titre }}</h3>
            <p class="subTitle">{{ campagne.titre }}</p>
            <el-divider/>
            <div>
                <el-image v-for="(item,index) of campagnes_modele.campagnes_modeles_langues"
                          :key="index"
                          :lazy='true'
                          fit="cover"
                          :style="!isMobile?{width:`${Number(360).mul(planArr[index].charAt(0))}px`}:{width: `100vw`}"
                          :src="`https://efashion-paris.com/front/img/modules/campagnes/page/${item.id_campagne_modele}/${item.id_campagne_modele}-${item.bloc}-${planArr[index]}-${lang}.jpg`"
                          @click="onClickCampagneImg(item)"
                          class="imgCampagne"
                />
            </div>
        </div>
    </div>
</template>

<script>

import {Message} from "element-ui";

let commonUtils = require('@/utils/common_utils');

export default {
    name: "Campagne",
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            lang: this.$store.state.lang,
            campagne: {//所有的活动数据
                campagnes_modeles: [{}],
            },
            campagnes_modele: {},//活动模型的数据，包括图片等
            planArr: [],
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.getCampagne();
        },
        async getCampagne() {
            let id_campagne = this.$route.query.id_campagne;
            let res = await this.$api.home.get_campagne({id_campagne});
            if (res.code != 0) return;
            this.campagne = res.data;
            if (commonUtils.isEmpty(this.campagne)) return;
            this.campagnes_modele = this.campagne.campagnes_modeles[0];
            this.planArr = this.campagnes_modele.plan.split('-');
        },
        onClickCampagneImg(item) {
            //从以下类型的链接里面取出 697或者907为商家id
            //https://www.efashion-paris.com/vendeurs/azaka-697/azaka-596.html
            //https://www.efashion-paris.com/vendeurs/best-angel-907.html
            //https://www.efashion-paris.com/vendeurs/best-angel-907/best-angel-908.html
            let line = item.lien;
            line = commonUtils.getCenterStr(line, '/vendeurs/', '.html');
            line = line.split('/')[0];
            line = line.split('-');
            line = line[line.length - 1];
            let id_vendeur = line;
            console.log(line);
            if (!id_vendeur) return Message.error(`can't get vendeur`);
            this.$router.push(`vendeur/${id_vendeur}`);
        },
    }
}
</script>


<style lang="less" scoped src="@/assets/viewCss/views/Campagne.less">
</style>
